import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";

export default function Movements() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/movements").then((r) => setItems(r.data)); }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 pt-10">
      <p className="overline">Schools & styles</p>
      <h1 className="serif text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-1 mb-10">Movements</h1>
      <div className="grid gap-px bg-border border border-border sm:grid-cols-2 lg:grid-cols-3">
        {items.map((m) => (
          <Link key={m.slug} to={`/movements/${m.slug}`} className="bg-card p-8 hover:bg-secondary/50 transition-colors group" data-testid={`movement-tile-${m.slug}`}>
            <div className="flex items-baseline justify-between gap-4">
              <h2 className="serif text-2xl group-hover:text-accent transition-colors">{m.name}</h2>
              <span className="text-sm text-muted-foreground shrink-0">{m.chair_count}</span>
            </div>
            <p className="overline mt-1">{m.period}</p>
            <p className="text-sm text-muted-foreground mt-3 line-clamp-3">{m.summary}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
